import { render } from "./AccountOverviewPage.vue?vue&type=template&id=571b14b9&scoped=true"
import script from "./AccountOverviewPage.vue?vue&type=script&lang=js"
export * from "./AccountOverviewPage.vue?vue&type=script&lang=js"

import "./AccountOverviewPage.vue?vue&type=style&index=0&id=571b14b9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571b14b9"]])

export default __exports__